import { customLogger } from "@/utils";
import { apiRequest } from "@/services/api";

const state = {
    notificationSound: true,
    audioSound: false,
    boxOpened: false,
    popupSeen: false,
    tabOpen: undefined,
    notification: false,
    mode: "chat",
    countMessageSession: 0,
    interactions: {},
    buttons_nav: {
        styleUlNav: {
            margin: "auto",
        },
        styleBPrev: {
            visibility: "hidden",
            marginTop: "35px",
        },
        styleBNext: {},
        styleTplBox: {},
        styleNavBox: {},
        stylePBC: {
            position: "absolute",
            bottom: "15px",
            fontSize: "11px",
            color: "gray",
            fontStyle: "italic",
            right: "15px",
        },
    },
    showAuthFlow: false,
    showSubsFlow: false,
    audioState: {
        audioActicated: true,
        indexPlayed: 0,
        audioPlayer: null,
        paused: false,
        play: false,
        inPlay: false
    },
    genai_mode: undefined,
};

const actions = {
    OPEN_BOX: ({ commit }) => {
        customLogger("OPEN BOX CALLED");
        commit("CLOSE_POPUP");
        commit("OPEN_BOX");
    },
    TRIGGER_AUDIO: async ({ state, commit, dispatch }, { text, index }) => {
      try{
        if (index && index == state.audioState.indexPlayed) {
            customLogger("SAME TTS CALLED");
            customLogger(state.audioState.audioPlayer.paused);
            if (!state.audioState.audioPlayer.paused) {
              await dispatch("TEXT_TO_SPEECH", { text, index });
            }else{
              await commit("PLAY_AUDIO");
            }
        } else {
            await dispatch("TEXT_TO_SPEECH", { text, index }); 
        }
      }catch(error){
        customLogger("Erreur lors de la lecture de l'audio", error);
        throw error;
      }
    },
    TEXT_TO_SPEECH: async ({ commit, state }, { text, index }) => {
        state.audioState.inPlay = true;
        await apiRequest()
            .post(
                "speechOpenai/textTospeech",
                { text: text },
                { responseType: "blob" }
            )
            .then(async (response) => {
                // customLogger(response.data);
                state.audioState.indexPlayed = index;
                const audioUrl = URL.createObjectURL(response.data);
                state.audioState.audioPlayer = new Audio(audioUrl);
                await commit("PLAY_AUDIO");
                //detecter la fin de l'audio
                state.audioState.audioPlayer.addEventListener("ended", () => {
                    commit("STOP_AUDIO");
                });
            })
            .catch((error) => {
                customLogger(error);
                state.audioState.play = false;
                state.audioState.inPlay = false;
            });
    },
};

const mutations = {
    INC_MSG_SESSION: (state, commit) => {
        state.countMessageSession += 1;
        customLogger("pass here !!!!", state.countMessageSession);
    },
    OPEN_BOX: (state, commit) => {
        state.boxOpened = true;
        state.notification = false;
    },
    CLOSE_BOX: (state) => {
        state.boxOpened = false;
    },
    SEE_POPUP: (state) => {
        state.popupSeen = true;
    },
    OPEN_TAB: (state, tab) => {
        state.tabOpen = tab;
    },
    PUSH_NOTIFICATION: (state) => {
        state.notification = true;
    },
    SET_MODE: (state, mode) => {
        state.mode = mode;
    },
    ADD_INTERACTION: (state, { key, value }) => {
        state.interactions[key] = value;
    },
    SET_STYLE_BTN: (state, data) => {
        state.buttons_nav = data;
    },
    SHOW_AUTH_FLOW: (state, value) => {
        state.showAuthFlow = value;
    },
    SHOW_SUBS_FLOW: (state, value) => {
        state.showSubsFlow = value;
    },
    PAUSE_AUDIO: (state) => {
        if (state.audioState.audioPlayer) {
            if (state.audioState.audioPlayer.paused) {
                state.audioState.audioPlayer.play();
                state.audioState.paused = false;
                state.audioState.play = true;
            } else {
                state.audioState.audioPlayer.pause();
                state.audioState.paused = true;
                state.audioState.play = true;
            }
        }
    },
    PLAY_AUDIO: async (state) => {
        try {
            if (state.audioState.audioPlayer) {
                await state.audioState.audioPlayer.play();
                state.audioState.paused = false;
                state.audioState.play = true;
            }
        } catch (error) {
            customLogger("Erreur lors de la lecture de l'audio", error);
            throw error;
        }
    },
    STOP_AUDIO: (state) => {
        if (state.audioState.audioPlayer) {
            state.audioState.audioPlayer.pause();
            state.audioState.audioPlayer.currentTime = 0;
            state.audioState.paused = false;
            state.audioState.play = false;
            state.audioState.inPlay = false;
        }
    },
    SET_GENAI_MODE: (state, mode) => {
        state.genai_mode = mode;
    },
};

export default {
    state,
    actions,
    mutations,
};
